import { render, staticRenderFns } from "./Summary.vue?vue&type=template&id=4bae10f4&lang=pug"
import script from "./Summary.vue?vue&type=script&lang=js"
export * from "./Summary.vue?vue&type=script&lang=js"
import style0 from "./Summary.vue?vue&type=style&index=0&id=4bae10f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/home/docker/code/frontend/components/Icon.vue').default,SummaryCard: require('/home/docker/code/frontend/components/SummaryCard.vue').default,PlanCard: require('/home/docker/code/frontend/components/PlanCard.vue').default,SendSummaryForm: require('/home/docker/code/frontend/components/SendSummaryForm.vue').default,PlanSelect: require('/home/docker/code/frontend/components/PlanSelect.vue').default,GroupSelect: require('/home/docker/code/frontend/components/GroupSelect.vue').default,UserGroupPlanSelect: require('/home/docker/code/frontend/components/UserGroupPlanSelect.vue').default,UploadFilesForm: require('/home/docker/code/frontend/components/UploadFilesForm.vue').default,Spinner: require('/home/docker/code/frontend/components/Spinner.vue').default})
